module.exports = __webpack_public_path__ + "media/images/rating_check_half-3546a6cb428d7881db0d2c10f1470f05.svg";